var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"25","y1":"0.5","y2":"0.5","stroke":"black","key":0}),React.createElement("line",{"x1":"25","y1":"9.5","y2":"9.5","stroke":"black","key":1})]);
}

MenuInline.defaultProps = {"width":"25","height":"10","viewBox":"0 0 25 10","fill":"none"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
